import React from "react";
import { PieChart, Pie, Cell, ResponsiveContainer } from "recharts";

const FollowerStats = ({ data }) => {
  const chartData = [
    {
      name: "Real Followers",
      value: parseFloat(data?.real_perc),
      color: "#4ade80",
    },
    {
      name: "Suspicious Followers",
      value: parseFloat(data?.fake_perc),
      color: "#f87171",
    },
  ];

  return (
    <div className="bg-card rounded-2xl lg:px-8 px-0 max-w-md mx-auto">
      <div className="flex items-center justify-between">
        <div className="space-y-6">
          { (typeof data?.fake_perc === "number" && data?.fake_perc > 0) && 
          <div>
            <div className="text-xl font-bold text-[#f87171] mb-1">
              {data?.fake_perc}%
            </div>
            <div className="text-sm text-muted-foreground font-medium">
              Suspicious Followers
            </div>
          </div>
          }
          {(typeof data?.real_perc === "number" && data?.real_perc > 0) && 
          <div>
            <div className="text-xl font-bold text-[#4ade80] mb-1">
              {data?.real_perc}%
            </div>
            <div className="text-sm text-muted-foreground font-medium">
              Real Followers
            </div>
          </div>
          }
        </div>

        { Array.isArray(chartData) && chartData.some(item => typeof item.value === "number" && item.value > 0) &&
        <div className="w-40 h-40">
          <ResponsiveContainer width="100%" height="100%">
            <PieChart>
              <Pie
                data={chartData}
                cx="50%"
                cy="50%"
                innerRadius={20}
                outerRadius={78}
                paddingAngle={2}
                dataKey="value"
                startAngle={90}
                endAngle={450}
              >
                {chartData.map((entry, index) => (
                  <Cell
                    key={`cell-${index}`}
                    fill={entry.color}
                    className="transition-all duration-300 hover:opacity-80"
                  />
                ))}
              </Pie>
            </PieChart>
          </ResponsiveContainer>
        </div>
        }
      </div>
    </div>
  );
};

export default FollowerStats;
